import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-system-select-popover',
  templateUrl: './system-select-popover.component.html',
  styleUrls: ['./system-select-popover.component.scss'],
  standalone: false
})
export class SystemSelectPopoverComponent {

  @Input() systems: any[] = [];
  @Input() selectedSystemId: number | null = null;

  constructor(private popoverController: PopoverController) {}

  selectSystem(system: any) {
    this.popoverController.dismiss({ system }, 'confirm');
  }

  trackBySystemId(index: number, item: any) {
    return item.id;
  }

}
